// extracted by mini-css-extract-plugin
module.exports = {"TodoApp__ContentContainer":"styles_TodoApp__ContentContainer__33rHS","TodoApp__Content":"styles_TodoApp__Content__28Bst"};